<template>
  <div class="mxr-product-item" v-if="product">
    <div class="mxr-product-item__title">
      <div class="row align-right">
        <div class="small-12 medium-8 column">
          <div class="row align-self-bottom">
            <div class="column shrink">
              <label v-if="variants.length">Taglia</label>
              <div v-if="selectedColor && product.productInfo.productId === selectedColor[1]">
                <select v-model="selectedVariant">
                  <option selected :value="{}" disabled>Scegli</option>
                  <option :key="variant.variantId" :value="variant" v-for="variant in selectedColor[0].productVariant">{{ variant.description }}</option>
                </select>
              </div>
              <div v-else>
                <select v-model="selectedVariant" v-if="product">
                  <option selected :value="{}" disabled>Scegli</option>
                  <option :key="variant.variantId" :value="variant" v-for="variant in variants">{{ variant.description }}</option>
                </select>
              </div>
            </div>
            <div>{{ currentProdPrice }}</div>
            <div class="column shrink align-self-bottom">
              <button v-if="variants.length" :disabled="!Object.keys(selectedVariant).length" @click="submitted" class="button cta-btn">AGGIUNGI AL CARRELLO</button>
              <button v-else class="button">AGGIUNGI AL CARRELLO</button>
            </div>
          </div>
        </div>
        <div class="small-12 medium-4 column">
          <small class="product-ref">
            Ref: {{ product.productInfo.productId }}
          </small>
          <div class="product-name">{{ product.openGraph.title }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-12 column">
        <p><strong>Progettato per {{ product.productInfo.productDescription }}</strong></p>
      </div>
    </div>
    <div class="row" v-if="(product.productContent.benefsUsers).length">
      <div class="column">
        <ul class="no-bullet row small-up-1 medium-up-2">
          <li class="column mxr-benefit" v-for="(benef, index) in product.productContent.benefsUsers">
            <div class="mxr-benefit__titlewrap">
              <span class="mxr-benefit__num" v-colorize="color">{{ index + 1}}</span>
              <div class="mxr-benefit__title">
                {{ benef.contentTitle }}
              </div>
            </div>
            <div class="mxr-benefit__content">
              <p>{{ benef.contentValue }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';

  export default {
    name: 'product-add',
    props: ['product'],
    data() {
      return {
        selectedVariant: {},
      };
    },
    computed: {
      variants() {
        return (this.product.productVariant || []);
      },
      ...mapGetters([
        'getItemIndex',
      ]),
      color() {
        return this.$parent.look.hex_color;
      },
      selectedColor() {
        return this.$store.state.selectedColor;
      },
      currentProdPrice() {
        let price = '';
        if (this.selectedColor && this.product.productInfo.productId === this.selectedColor[1]) {
          price = this.selectedColor[0].productVariant[0].price;
        } else if (this.selectedColor
          && this.product.productInfo.productId === this.selectedColor[1] && this.selectedVariant) {
          price = this.selectedVariant.price;
        } else {
          price = this.variants[0].price;
        }
        // return price;
        this.$parent.$emit('currentProdPrice', price);
        price = '';
      },
    },
    methods: {
      ...mapMutations(['addToCart']),
      submitted() {
        const variant = {};
        variant.id = this.selectedVariant.variantId;
        variant.quantity = 1;
        variant.name = this.product.openGraph.title;
        variant.price = this.selectedVariant.price;
        variant.image = this.selectedColor ?
          this.selectedColor[0].openGraph.image : this.product.openGraph.image;
        variant.size = this.selectedVariant.description;
        variant.currency = this.selectedVariant.currency;
        const indexExistingId = this.getItemIndex(variant.id);
        if (indexExistingId !== -1) {
          this.$store.commit('incrementQty', indexExistingId);
        } else {
          this.addToCart({ variant });
        }
        this.selectedVariant = {};
        this.$cookie.set('basket', JSON.stringify(this.$store.state.cart), 30);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mxr-benefit {
    margin-bottom: rem-calc(50);
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      background: $black;
      height: rem-calc(2);
      width: rem-calc(20);
      left: rem-calc(10);
      @include breakpoint(medium) {
        left: rem-calc(15);
      }
    }
    &__num {
      font-size: rem-calc(50);
      position: relative;
      margin-right: rem-calc(40);
      // overflow: hidden;
      padding-right: rem-calc(10);
      font-weight: 300;
      line-height: 1.2;
      &:after {
        content: '';
        position: absolute;
        border-left: rem-calc(2) solid lighten($blue-gray, 12%);
        height: 100%;
        width: 100%;
        transform: skewX(-10deg) translateY(-50%);
        left: 100%;
        top: 50%;
      }
    }
    &__titlewrap {
      display: flex;
      align-items: center;
      margin-bottom: rem-calc(30);
      position: relative;
    }
    &__title {
      padding: rem-calc(10 0);
      text-transform: uppercase;
      font-weight: $global-weight-bold;
      font-family: $body-font-family-alt;
      font-style: italic;
      font-size: rem-calc(14);
      position: relative;
    }
  }
  .mxr-product-item {
    &__figure {
      width: 100%;
      margin: auto;
      text-align: right;
    }
    &__img {
      img {
        margin: auto;
        display: block;
        max-width: 45%;
        -webkit-user-drag: none;
      }
    }
    &__title {
      margin: rem-calc(20 0);      
      position: relative;
      .product-ref {
        color: darken($blue-gray, 12%);
        font-size: rem-calc(12);
        text-align: right;
        display: block;
      }
      .product-name {
        font-size: rem-calc(20);
        font-family: $body-font-family-alt;
        font-style: italic;
        text-align: right;
      }
      &:after {
        content: '';
        position: absolute;
        background: $blue-gray;
        opacity: .5;
        height: rem-calc(2);
        width: rem-calc(50);
        top: 100%;
        right: rem-calc(10);
        @include breakpoint(medium) {
          right: rem-calc(15);
        }
      }
      label {
        font-family: $body-font-family-alt;
        font-weight: $global-weight-bold;
        text-transform: uppercase;
        font-style: italic;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductAdd.vue?76d0643c